import { LeadInactivityTypeEnum } from "enums/lead-inactivity-type.enum";

export const ALL_SOURCE_OFFICES = "all" as const;

export const UNASSIGNED_SOURCE_OFFICE = 0;

export type TSourceOfficeSelection = number | typeof ALL_SOURCE_OFFICES;

export const LEAD_INACTIVITY_TYPE_LABELS: Record<
  LeadInactivityTypeEnum,
  string
> = {
  [LeadInactivityTypeEnum.REROUTE_TO_OFFICE]: "Redirect to office",
};
